import { Box, Button, IconButton, Stack, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  DealRoomPropertyThumbnails,
  galleryUrlsForProperty,
} from '@/components/DealRoom/DealRoomPropertyThumbnails';
import type { PropertyView } from '@/types/PropertyView';

interface DealRoomSidebarTopProps {
  property: PropertyView;
}

export const DealRoomSidebarTop = ({ property }: DealRoomSidebarTopProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const thumbs = galleryUrlsForProperty(property);

  return (
    <Box
      sx={{
        px: 1.5,
        pt: 1.5,
        pb: 1.25,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
        {thumbs.length > 0 ? (
          <DealRoomPropertyThumbnails
            urls={thumbs}
            addressLabel={property.address || 'Property'}
          />
        ) : null}

        <IconButton
          size="medium"
          onClick={() => navigate('/properties')}
          aria-label="Back to properties"
          sx={{
            flexShrink: 0,
            ml: 'auto',
            color: theme.palette.text.primary,
            '&:hover': {
              bgcolor: 'action.hover',
              color: theme.palette.text.primary,
            },
            '& i': {
              fontSize: 20,
              fontWeight: 600,
            },
          }}
        >
          <i className="fa-solid fa-arrow-left" />
        </IconButton>
      </Stack>

      {property.hasStartedContract ? (
        <Button
          href={`/contract/${property.productId}`}
          variant="outlined"
          size="small"
          fullWidth
          startIcon={<i className="fa-light fa-binoculars" />}
          sx={{ mt: 1.25, textTransform: 'none', fontWeight: 600 }}
        >
          View Contract
        </Button>
      ) : null}
    </Box>
  );
};

export default DealRoomSidebarTop;
